// extracted by mini-css-extract-plugin
module.exports = {"white-color":"styles_white-color__35XZR","black-color":"styles_black-color__13q20","loadmore_container":"styles_loadmore_container__2TNkl","carColumn":"styles_carColumn__11K8v"};